<template>
  <input
    :id="`radio-color-picker-${htmlId}`"
    v-model="selectedRadio"
    type="radio"
    :name="groupName"
    :value="value"
  />
  <label
    class="flex flex-column cursor-pointer"
    :for="`radio-color-picker-${htmlId}`"
  >
    <span class="sr-only">Färg: {{ label }}</span>
    <span
      class="w-32 h-32 rounded-full border-border-tertiary border-md border-solid relative"
      :style="{ backgroundColor: color }"
    ></span>
  </label>
</template>

<script lang="ts" setup>
interface Props {
  color: string;
  groupName?: string;
  htmlId: string;
  label?: string;
  value?: string;
}
withDefaults(defineProps<Props>(), {
  label: '',
  value: '',
  groupName: 'radioknappar',
});

const selectedRadio = defineModel<string>();
</script>

<style scoped lang="scss">
input {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 0.1rem;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  + label {
    padding: 0.6rem;
  }
  &:checked {
    + label {
      border: 0.2rem solid var(--border-primary);
      padding: 0.4rem;
      border-radius: 50%;
    }
  }
  &:hover {
    + label {
      border: 0.2rem solid var(--border-primary);
      padding: 0.4rem;
      border-radius: 50%;
    }
  }
}
</style>
